import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AppStateService } from '../../app-state/app-state.service';
import { HTTP_STATUS_OFFLINE } from '../../http/httpError';
import { AsyncPipe } from '@angular/common';

@Component({
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class ErrorPageComponent implements OnInit {
  status: string;

  statusToHeadlineMapping = {
    [HTTP_STATUS_OFFLINE]: $localize`'Keine Verbindung zum Internet`,
    ['0']: $localize`Es konnten keine Daten abgerufen werden`,
    ['404']: $localize`Seite oder Objekt nicht gefunden`,
    ['500']: $localize`Interner Server Fehler`,
    ['401']: $localize`Bitte zunächst einloggen`,
    ['403']: $localize`Es fehlt die Berechtigung, um die gewünschte Aktion auszuführen`,
  };

  wasOffline!: boolean;
  isOffline$!: Observable<boolean>;
  isOnline$!: Observable<boolean>;

  constructor(
    private route: ActivatedRoute,
    private appState: AppStateService,
  ) {}

  ngOnInit() {
    this.status = this.route.snapshot.params['status'] || '404';
    this.wasOffline = !this.appState.isOnline.getValue();
    this.isOffline$ = this.appState.isOffline;
    this.isOnline$ = this.appState.isOnline;
  }

  refresh() {
    this.appState.reload();
  }
}
